<template>
    <div class="detail-package-strip">
        <div class="touch-strip" @click="showPackagePopup">
            <div class="content">
                <h2>选择<span>商品类型/数量</span></h2>
            </div>
            <i class="arrow"></i>
        </div>
    </div>
    
</template>

<script>

export default {
    name: 'package',
    data() {
        return {
        }
    },
    props: {
    },
    computed: {
    },
    methods: {
        showPackagePopup () {
            this.$emit('openPackagePopup');
        }
    }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Package.vue